export default __webpack_public_path__ + "static/media/founders.f05cda54.png";